export const login = {
  button: 'Ingresá',
}

export const signup = {
  button: 'Registrate',
}

export const business = {
  categories: 'Categorías',
  catalog: 'Catálogo',
}

export const objectList = {
  noObjectsMessage: 'No se encontraron objetos',
}

export const endpoint = {
  somethingWentWrong: 'Algo salió mal',
  internetMayBeTheProblem: 'Algo salió mal, revisá tu conexión a internet',
}

export const creditCardInput = {
  number: {
    placeholder: 'Número de tarjeta',
  },
  expiry: {
    label: 'Fecha de vencimiento',
    placeholder: 'MM / AA',
  },
  cvc: {
    label: 'Código de seguridad',
    placeholder: 'CVV',
  },
  cardholderName: {
    label: 'Nombre del titular',
  },
  documentType: {
    label: 'Tipo de documento',
  },
  documentNumber: {
    label: 'Nro. de documento',
  },
}



// WEBPACK FOOTER //
// ./src/common/text.js